import React from 'react';

function MainHeader() {
  return (
    <h1>Working Hard or Quick Break?</h1>
  )
}

export default MainHeader;
